<template>
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
      <path class="cls-5" d="m75.49,77.83H13.22c-.93,0-1.69-.76-1.69-1.69V13.86c0-.93.76-1.69,1.69-1.69s1.69.76,1.69,1.69v60.58h60.58c.93,0,1.69.76,1.69,1.69s-.76,1.69-1.69,1.69Z"/>
      <path class="cls-5" d="m13.22,66.7c-.4,0-.8-.14-1.12-.42-.7-.62-.77-1.69-.15-2.39l8.66-9.79c.31-.35.75-.56,1.21-.57.46-.04.92.16,1.25.49l6.48,6.44,29.79-34.69c.58-.67,1.57-.78,2.29-.26l6.08,4.47,6.46-8.19c.58-.73,1.64-.86,2.38-.28.73.58.86,1.64.28,2.38l-7.47,9.48c-.56.72-1.59.86-2.33.32l-6.14-4.51-29.95,34.88c-.31.36-.75.57-1.22.59-.47.02-.93-.16-1.26-.49l-6.5-6.46-7.47,8.45c-.33.38-.8.57-1.27.57Z"/>
      <circle class="cls-1" cx="44.36" cy="45" r="15.13"/>
      <path class="cls-2" d="m44.36,61.18c-8.92,0-16.18-7.26-16.18-16.18s7.26-16.18,16.18-16.18,16.18,7.26,16.18,16.18-7.26,16.18-16.18,16.18Zm0-30.25c-7.76,0-14.07,6.31-14.07,14.07s6.31,14.07,14.07,14.07,14.07-6.31,14.07-14.07-6.31-14.07-14.07-14.07Z"/>
      <circle class="cls-3" cx="21.82" cy="55.99" r="2.98"/>
      <circle class="cls-3" cx="29.62" cy="62.61" r="2.98"/>
      <circle class="cls-3" cx="60.8" cy="27.39" r="2.98"/>
      <circle class="cls-3" cx="67.92" cy="31.8" r="2.98"/>
      <circle class="cls-3" cx="75.49" cy="22.83" r="2.98"/>
      <g>
        <g>
          <rect class="cls-6" x="41.05" y="41.07" width=".74" height="12.56"/>
          <rect class="cls-6" x="46.92" y="41.37" width=".74" height="12.56"/>
        </g>
        <g>
          <rect class="cls-6" x="36.16" y="44.64" width="16.39" height=".74"/>
          <rect class="cls-6" x="36.16" y="49.64" width="16.39" height=".74"/>
        </g>
        <g>
          <path class="cls-5" d="m52.18,39.9v1.56h-15.65v-1.56c0-1.09.89-1.98,1.98-1.98h11.68c1.09,0,1.98.89,1.98,1.98Z"/>
          <path class="cls-5" d="m52.55,41.83h-16.39v-1.93c0-1.29,1.06-2.35,2.36-2.35h11.68c1.3,0,2.36,1.05,2.36,2.35v1.93Zm-15.65-.74h14.9v-1.19c0-.89-.72-1.61-1.61-1.61h-11.68c-.89,0-1.61.72-1.61,1.61v1.19Z"/>
        </g>
        <path class="cls-5" d="m50.19,53.93h-11.68c-1.3,0-2.36-1.05-2.36-2.35v-10.5h16.39v10.5c0,1.3-1.06,2.35-2.36,2.35Zm-13.29-12.1v9.75c0,.89.72,1.61,1.61,1.61h11.68c.89,0,1.61-.72,1.61-1.61v-9.75h-14.9Z"/>
        <g>
          <path class="cls-4" d="m41.21,39.45c-.41,0-.74-.33-.74-.74v-1.9c0-.41.33-.74.74-.74s.74.33.74.74v1.9c0,.41-.33.74-.74.74Z"/>
          <path class="cls-4" d="m47.51,39.45c-.41,0-.74-.33-.74-.74v-1.9c0-.41.33-.74.74-.74s.74.33.74.74v1.9c0,.41-.33.74-.74.74Z"/>
        </g>
      </g>
    </svg>
</template>

<script>
export default {
    name: "MetricsByWeekIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #0f5b71;
  }
  .cls-3 {
    fill: #0b5e73;
  }
  .cls-4 {
    fill: #0c5f74;
  }
  .cls-5 {
    fill: #59c5c7;
  }
  .cls-6 {
    fill: #b6dfcf;
  }
</style>
